module.exports = __webpack_public_path__ + "static/media/arrows-alt-v.8bd41f9b.svg";